import NetSummary from "./NetSummary";
import { useState } from "react";
import { useEffect } from "react";
import FormField from "../FormField";
import InputFactory from "../../../../../components/InputFactory";
import { dialog } from "../../../../../nq-component";
import { parseFormattedNumber } from "./utils";

function Form({
  formData,
  client,
  handleSubmit,
  minDate,
  maxDate,
  schema,
  schemas,
  onChange,
  setFormData,
  tinNo,
  resetRef,
  user,
  disabled,
  clientId,
  progress,
  ...props
}) {
  const [_formData, _setFormData] = useState({
    ...formData,
  });
  const [uploading, setUploading] = useState(0);

  useEffect(() => {
    _setFormData(formData);
  }, [formData]);

  return (
    <>
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-1">
        <div className="d-flex flex-column flex-md-row gap-2 py-2 align-content-stretch">
          <InputFactory
            type="Image"
            field="image"
            object={_formData}
            value={_formData?.image || ""}
            defaultValue={_formData?.image || ""}
            className="bg-white col-md-6 col-12"
            placeholder="Upload Receipt Image"
            setUploading={setUploading}
            onChange={onChange}
            disabled={disabled}
          />

          <div className="d-flex flex-column gap-2 my-2">
            <FormField label="Date" required>
              <InputFactory
                type="Date"
                field="date"
                required
                min={minDate}
                max={maxDate}
                placeholder="Enter Date"
                // value={_formData?.date || ""}
                defaultValue={_formData?.date.slice(0, 10) || ""}
                className="border border-1 border-dark-subtle bg-white"
                onChange={onChange}
                disabled={disabled}
              />
            </FormField>

            <div className="d-flex gap-2">
              <FormField label="Client" required>
                <InputFactory
                  type="Pointer"
                  target="clients"
                  schema={schema}
                  schemas={schemas}
                  field="client"
                  includes={["all"]}
                  required
                  keys={["tinNo", "isVatable", "city", "user"]}
                  resetRef={resetRef}
                  placeholder="Select Client"
                  defaultValue={_formData?.client || ""}
                  className="border border-1 border-dark-subtle bg-white"
                  onChange={onChange}
                  where={{
                    user: { id: user?.id },
                    clientOf: "client",
                    isActive: true,
                  }}
                  disabled={disabled}
                />
              </FormField>

              <FormField label="TIN">
                <InputFactory
                  type="String"
                  target="clients"
                  //   field="supplier"
                  placeholder="000-000-000"
                  value={tinNo}
                  className="border border-1 border-dark-subtle bg-light"
                  //   onChange={onChange}
                  disabled
                />
              </FormField>
            </div>

            <InputFactory
              type="Boolean"
              field="isVatable"
              label="is it VATable?"
              value={_formData?.isVatable ?? false}
              className="fw-medium text-primary"
              onChange={onChange}
              disabled={disabled}
            />

            <FormField label="Bank" required>
              <InputFactory
                type="Pointer"
                target="banks"
                schema={schema}
                schemas={schemas}
                field="bank"
                includes={["all"]}
                keys={["balance"]}
                required
                resetRef={resetRef}
                placeholder="Select Bank"
                defaultValue={_formData?.bank || ""}
                className="border border-1 border-dark-subtle bg-white"
                onChange={onChange}
                where={{
                  client: { id: clientId },
                }}
                disabled={disabled}
              />
            </FormField>

            <div className="d-flex gap-2">
              <div className="flex-grow-1 min-w-0">
                <FormField
                  label="Total Sales"
                  sublabel="VAT-inclusive"
                  required
                >
                  <InputFactory
                    type="Currency"
                    field="gross"
                    required
                    placeholder="0.00"
                    // value={tinNo}
                    defaultValue={_formData?.gross || ""}
                    className="border border-1 border-dark-subtle bg-white w-100"
                    onChange={onChange}
                    disabled={disabled}
                  />
                </FormField>
              </div>

              {_formData?.isVatable && (
                <FormField label="VAT Exempt">
                  <InputFactory
                    type="Currency"
                    field="vatExempt"
                    placeholder="0.00"
                    defaultValue={_formData?.vatExempt}
                    className="border border-1 border-dark-subtle bg-white w-100"
                    onChange={onChange}
                    disabled={disabled}
                  />
                </FormField>
              )}
            </div>

            {_formData?.isVatable && (
              <FormField label="Zero Rated">
                <InputFactory
                  type="Currency"
                  field="zeroRated"
                  placeholder="0.00"
                  defaultValue={_formData?.zeroRated}
                  className="border border-1 border-dark-subtle bg-white w-100"
                  onChange={onChange}
                  disabled={disabled}
                />
              </FormField>
            )}
          </div>
        </div>
        <NetSummary
          vat={_formData.vat}
          net={_formData.net}
          object={_formData}
          setFormData={setFormData}
        />
        <div className="d-flex gap-2">
          <button
            type="button"
            className="flex-fill btn btn-light fw-bold"
            onClick={() => dialog.close()}
            style={{ backgroundColor: "#D1D1D1" }}
          >
            Close
          </button>
          {!disabled && (
            <button
              disabled={uploading > 0}
              type="submit"
              className="flex-fill btn btn-primary fw-bold"
            >
              {uploading > 0
                ? "Uploading..."
                : _formData.status === "draft"
                  ? "Update"
                  : "Save"}
            </button>
          )}
        </div>
      </form>
    </>
  );
}

export default Form;
